import clsx from 'clsx'
import { useTranslation } from 'react-i18next'

import type { CompletePanelProps } from './type'

import { Button } from '@/components/ui'

export const CompletePanel = ({ onClose }: CompletePanelProps) => {
  const { t } = useTranslation()

  return (
    <div className="tw-w-full tw-px-2 tw-pb-2">
      <div className="tw-mt-10 tw-text-center">
        {t('auth.email.complete.message')}
      </div>
      <p className="tw-mt-14 tw-px-4">{t('auth.email.complete.instruction')}</p>
      <div className={clsx('tw-mt-16')}>
        <Button type="button" variant="normal" onClick={onClose}>
          {t('auth.email.close')}
        </Button>
      </div>
    </div>
  )
}
